import { CancelToken } from 'axios';
import candidateHistoryService from './candidate-history.service';
import { Module } from 'vuex';
import { StoreState } from '@/core/models/store.interface';

export interface CandidateHistoryState {}

const CandidateHistoryStore: Module<CandidateHistoryState, StoreState> = {
   namespaced: true,
   state: {},

   getters: {},

   mutations: {},

   actions: {
      async get(
         context,
         { slot_id, cancel_token, page, per_page }: { slot_id: number; cancel_token: CancelToken; page: number; per_page: number },
      ) {
         return await candidateHistoryService.get({ slot_id, cancel_token, page, per_page }).then((response) => {
            return response;
         });
      },
   },
};

export default CandidateHistoryStore;
